module.exports = __webpack_public_path__ + "static/media/left-right.948235dc.svg";